var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClanActivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 124C8 188.065 59.935 240 124 240C188.065 240 240 188.065 240 124C240 59.935 188.065 8 124 8C59.935 8 8 59.935 8 124ZM124 0C55.5167 0 0 55.5167 0 124C0 192.483 55.5167 248 124 248C192.483 248 248 192.483 248 124C248 55.5167 192.483 0 124 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.538 48C129.538 45.7909 127.748 44 125.538 44C123.329 44 121.538 45.7909 121.538 48V117.415H48C45.7909 117.415 44 119.206 44 121.415C44 123.625 45.7909 125.415 48 125.415H121.538V200C121.538 202.209 123.329 204 125.538 204C127.748 204 129.538 202.209 129.538 200V125.415H200C202.209 125.415 204 123.625 204 121.415C204 119.206 202.209 117.415 200 117.415H129.538V48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClanActivation);
export default __webpack_public_path__ + "static/media/clan-activation.1d19309c4828535b539c66ddc7173a0a.svg";
export { ForwardRef as ReactComponent };